import { API } from '@/services/api'

function findNearest(latitude, longitude) {
  return API.get(`/cities/find-nearest?latitude=${latitude}&longitude=${longitude}`)
}

export const citiesService = {
  findNearest,
}
